<template>
    <div>
        <!-- text input -->
        <fg-input
            v-if="input.fieldtype == 'text' && input.render"
            :label="`${ (prefix) ? prefix : '' }${input.displayname}`"
            :help="input.description"
            :priced="(input.price > 0)" 
            :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
            v-model="input.value"
            :required="input.required"
            :description="input.description"
            type="text"
            inputClasses="form-control-sm"
        />
        <!-- end text input -->

        <!-- email input -->
        <fg-input
            v-if="input.fieldtype == 'email' && input.render"
            :label="`${ (prefix) ? prefix : '' }${input.displayname}`"
            :help="input.description"
            :priced="(input.price > 0)" 
            :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
            v-model="input.value"
            :required="input.required"
            :description="input.description"
            type="email"
            inputClasses="form-control-sm"
        />
        <!-- end text input -->

        <!-- number input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'number' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <el-input-number v-model="input.value" size="medium" :min="parseInt(input.options[0])" :max="parseInt(input.options[1])"></el-input-number>
        </div>
        <!-- end number input -->

        <!-- radio input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'radio' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <n-radio v-for="(option, index) in input.options" :key="index" v-model="input.value" :label="`${option.name}:::${option.price}`">{{ option.name }}</n-radio>
        </div>
        <!-- end radio input -->

        <!-- checkbox input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'checkbox' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <!-- <n-checkbox v-for="(option, index) in input.options" :key="index" v-model="input.value" :name="option.name" :value="`${option.name}:::${option.price}`">{{ option.name }}</n-checkbox> -->
            <el-checkbox-group v-model="input.value">
                <el-checkbox v-for="(option, index) in input.options" :key="index" :label="`${option.name}:::${option.price}`" :name="option.name">{{ option.name }}</el-checkbox>
            </el-checkbox-group>
        </div>
        <!-- end checkbox input -->

        <!-- single select input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'select-single' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <div>
                <el-select class="select-primary"
                            clearable
                            filterable
                            :required="input.required"
                            :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
                            v-model="input.value">
                    <el-option v-for="(option, index) in input.options"
                            class="select-primary"
                            :value="`${option.name}:::${option.price}`"
                            :label="option.name"
                            :key="index">
                    </el-option>
                </el-select>
            </div>
            
        </div>
        <!-- end single select input -->

        <!-- multiple select input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'select-multiple' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <div>
                <el-select multiple
                    clearable
                    filterable
                    collapse-tags
                    class="select-primary"
                    v-model="input.value"
                    :required="input.required"
                    :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`">
                    <el-option v-for="(option, index) in input.options"
                            class="select-primary"
                            :value="`${option.name}:::${option.price}`"
                            :label="option.name"
                            :key="index">
                    </el-option>
                </el-select>
            </div>
        </div>
        <!-- end multiple select input -->

        <!-- switch input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'switch' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <n-switch v-model="input.value" :onText="input.options[0].name" :offText="input.options[1].name"></n-switch>
        </div>
        <!-- end switch input -->

        <!-- datepicker input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'datepicker' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <el-date-picker v-model="input.value" type="date" :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"></el-date-picker>
        </div>
        <!-- end datepicker input -->

        <!-- datetimepicker input -->
        <div  class="form-group has-label" v-if="input.fieldtype == 'datetimepicker' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <el-date-picker v-model="input.value" type="datetime" :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"></el-date-picker>
        </div>
        <!-- end datetimepicker input -->

        <!-- student select input -->
        <div  class="form-group has-label" v-if="(input.fieldtype == 'student' || input.fieldtype == 'teacher') && input.render">
            <fg-input
                v-if="input.readonly"
                :readonly="input.readonly"
                :label="`${ (prefix) ? prefix : '' }${input.displayname}`"
                :help="input.description"
                :priced="(input.price > 0)" 
                :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
                v-model="input.value"
                :required="input.required"
                :description="input.description"
                type="text"
                inputClasses="form-control-sm"
            />
            <template v-else>
                <label>
                    {{ input.displayname }}
                    <span v-if="input.required" class="required">*</span>
                    <span v-if="(input.price > 0)" class="priced">₹</span>
                    <small class="text-muted help-text" >{{ input.description }}</small>
                </label>
                <div>
                    <el-select class="select-primary"
                                clearable
                                filterable
                                :required="input.required"
                                :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
                                v-model="input.value">
                        <el-option v-for="(option, index) in selection_pool"
                                class="select-primary"
                                :value="option.register_no"
                                :label="`${option.register_no} - ${option.name}`"
                                :key="index">
                        </el-option>
                    </el-select>
                </div>
            </template>
        </div>
        <!-- end student select input -->

        <!-- participant select input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'participant' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <div>
                <el-select class="select-primary"
                            clearable
                            filterable
                            :required="input.required"
                            :placeholder="`${ (prefix) ? prefix : '' }${input.displayname}`"
                            v-model="input.value">
                    <el-option v-for="(option, index) in selection_pool"
                            class="select-primary"
                            :value="option.email"
                            :label="`${option.name} - ${option.email}`"
                            :key="index">
                    </el-option>
                </el-select>
            </div>
        </div>
        <!-- end participant select input -->

        <!-- file input -->
        <div class="form-group has-label" v-if="input.fieldtype == 'file' && input.render">
            <label>
                {{ input.displayname }}
                <span v-if="input.required" class="required">*</span>
                <span v-if="(input.price > 0)" class="priced">₹</span>
                <small class="text-muted help-text" > {{ input.description }}</small>
            </label>
            <div>
                <el-upload
                    ref="fileUploader"
                    class="file-uploader"
                    name="image"
                    list-type="text"
                    accept=""
                    :limit="1"
                    :data="{path: 'tukio/forms/'}"
                    :action="uploadURL"
                    :headers="headers"
                    :show-file-list="true"
                    :multiple="false"
                    :auto-upload="true"
                    :on-success="handleFileSuccess"
                    :before-remove="handleRemove"
                    :before-upload="beforeFileUpload">
                    <!-- <div v-if="input.value" class="file" :style="`background-image: url(${input.value})`"></div> -->
                    <i class="el-icon-plus file-uploader-icon"></i>
                </el-upload>
            </div>
        </div>
        <!-- end fileinput -->
    </div>
</template>

<script>

import { FormGroupInput, Card, Button, Radio, Switch } from 'src/components';
import {Select, Option, Checkbox, CheckboxGroup, Upload} from 'element-ui';
import { mapGetters } from 'vuex';
export default {
    name: 'CustomInputs',
    components: {
        [Radio.name]: Radio,
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        // [Checkbox.name]: Checkbox,
        [Switch.name]: Switch,
        [FormGroupInput.name]: FormGroupInput,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Upload.name]: Upload
    },
    props: {
        input: Object,
        prefix: String,
        pool: {
            type: Array,
            default: () => []
        }
    },
    data(){
        return {
            selection_pool: [],
            user: null,
            file_url: null
        }
    },
    watch: {
        pool: {
            handler: function(pool, oldPool){
                this.getPool()
            }
        }
    },
    mounted(){
        this.getPool()
    },
    computed:{
        ...mapGetters({
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences',
        }),
        headers(){
            this.authTokens['content-type'] = 'multipart/form-data'
            let {token, refreshtoken} = this.authTokens
            return {token, refreshtoken};
        },
        uploadURL(){
            return `${process.env.VUE_APP_BASE_URL}/tukio/upload`
        }
    },
    methods: {
        async getPool(){
            let ret = []
            switch(this.input.fieldtype){
                case 'student': 
                    ret = await this.$store.dispatch('getStudentsByBatches', this.pool)
                    break
                case 'teacher':
                    ret = await this.$store.dispatch('getTeachersByDepartments', this.pool)
                    break 
                case 'participant': 
                    ret = this.pool 
                    break
                default: 
                    ret = this.pool 
                    break
            }
            this.selection_pool = ret
            // console.log("TCL: getPool -> this.selection_pool", this.selection_pool)
            this.$nextTick(() => {
                this.selection_pool = ret
            })
        },
        handleRemove(file, fileList){
            this.input.value = null
        },
        handlePreview(file) {
            this.input.value = URL.createObjectURL(file.raw);
        },
        handleFileSuccess(res, file) {
            console.log("🚀 ~ file: CustomInputs.vue ~ line 349 ~ handleFileSuccess ~ res", res)
            this.input.value = res.data.image;
        },
        beforeFileUpload(file) {
            const isLt12M = file.size / 1024 / 1024 < 12;
            if (!isLt12M) {
                this.$notify({
                    message: `File size can not exceed 12MB!`,
                    icon: 'fa fa-bell',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            }
            return isLt12M;
        },
    }
}
</script>

<style >
.el-select{
    width: 100%;
}
.el-select .el-input .el-input__inner{
    margin: 1px 1px;
}
.text-muted.help-text{
    display: block;
    margin-top: 15px;
    margin-left: 0!important;
    /* min-height: 15px; */
}
</style>
